import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { differenceInDays } from 'date-fns';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

import { AuthService } from '@features/auth/auth.service';
import { ProfileService } from '@features/profile/profile.service';
import { ToasterService } from '@ui-kit/app-toast/toaster.service';
import { handleError } from '@ui-kit/utility/handleHttpErrorResponse';
import { CrudService, PostEntityModel } from 'collection';

@Injectable({
  providedIn: 'root'
})
export class ConfirmEmailBannerService {
  isEmailConfirmedOpened: boolean;

  resendEmailConfirmation: PostEntityModel;

  isEmailConfirmOpened: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  emailHasToBeFocused: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private _destroyed$ = new Subject();

  constructor(
    private _auth: AuthService,
    private _crud: CrudService,
    private _router: Router,
    private _profileService: ProfileService,
    private _toastService: ToasterService
  ) {
    this.resendEmailConfirmation = this._crud.createPostEntity({ name: 'user/resend-email-confirmation' });
    this.emailHasToBeFocused = this._profileService.emailHasToBeFocused;
  }

  getProfileData(): Observable<any> {
    return this._auth.initProfile();
  }

  initConfirmEmailAlert(myProfileData, accountData): void {
    if (myProfileData && accountData) {
      const currentDate = new Date(Date.now());
      const isUserEmailConfirmed: boolean = myProfileData?.email_confirmed;
      const accountCreatedAt = new Date(myProfileData?.account_created_at);
      const createdAtToCurrentDateDiff = differenceInDays(currentDate, accountCreatedAt);

      if (myProfileData.email === accountData.contact_person_email && createdAtToCurrentDateDiff >= 3 && !isUserEmailConfirmed) {
        this.isEmailConfirmOpened.next(true);
      }
    }
  }

  closeEmailConfirmBanner(): void {
    this.isEmailConfirmOpened.next(false);
  }

  resendEmailConfirm(): void {
    this.resendEmailConfirmation
      .save({})
      .pipe(
        takeUntil(this._destroyed$),
        catchError(({ error }) => {
          handleError(error, this._toastService);
          return of(null);
        })
      )
      .subscribe();

    this.closeEmailConfirmBanner();
  }

  changeEmail(): void {
    this._router.navigate(['app/profile/general']).then(() => {
      this.emailHasToBeFocused.next(true);
      this.closeEmailConfirmBanner();
    });
  }
}
